import { FunctionComponent } from 'react';
import styles from "./ContentManagementCardSkeleton.module.css";
import cn from 'classnames';

interface IContentManagementCardSkeletonProps {
    className?: string;
}

const ContentManagementCardSkeleton: FunctionComponent<IContentManagementCardSkeletonProps> = ({ className }) => {
    return (
        <div className={cn(styles.contentManagementCardSkeleton, 'shimmer-bg', className)}>
            <div className={styles.contentManagementCardSkeletonHeader}></div>
            <div className={styles.contentManagementCardSkeletonBody}>
                <div className={styles.contentManagementCardSkeletonTag}></div>
                <div className={styles.contentManagementCardSkeletonTitle}></div>
                <div className={styles.contentManagementCardSkeletonSummary}></div>
                <div className={styles.contentManagementCardSkeletonMeta}>
                    <div className='d-flex align-items-center'>
                        <div className={styles.contentManagementCardSkeletonUserImage}></div>
                        <div className={styles.contentManagementCardSkeletonUserName}></div>
                    </div>
                    <div className={styles.contentManagementCardSkeletonLikesShares}>
                        <div className={styles.contentManagementCardSkeletonLike}></div>
                        <div className={styles.contentManagementCardSkeletonShare}></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContentManagementCardSkeleton;
